module.exports = __webpack_public_path__ + "img/i-hospital-2.8b9036ac.png";